// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-Breadcrumbs-styles___breadcrumbs--X8AoF {
  display: flex;
  align-items: center;
}

  .components-Breadcrumbs-styles___breadcrumbs--X8AoF .components-Breadcrumbs-styles___breadcrumb--vDSlX {
    color: #6d717a;
    font-size: 13px;
    padding: 0 6px 0 0;
    display: flex;
    align-items: center;
  }

  .components-Breadcrumbs-styles___breadcrumbs--X8AoF .components-Breadcrumbs-styles___breadcrumb--vDSlX.components-Breadcrumbs-styles___breadcrumbLink--NeSDk {
      cursor: pointer;
    }

  .components-Breadcrumbs-styles___breadcrumbs--X8AoF .components-Breadcrumbs-styles___icon--v8MDj {
    width: 10px;
    margin-left: 6px;
  }
`, "",{"version":3,"sources":["webpack://./components/Breadcrumbs/styles.pcss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AAkBrB;;EAhBE;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;EAKrB;;EAHE;MACE,eAAe;IACjB;;EAGF;IACE,WAAW;IACX,gBAAgB;EAClB","sourcesContent":[".breadcrumbs {\n  display: flex;\n  align-items: center;\n\n  .breadcrumb {\n    color: #6d717a;\n    font-size: 13px;\n    padding: 0 6px 0 0;\n    display: flex;\n    align-items: center;\n\n    &.breadcrumbLink {\n      cursor: pointer;\n    }\n  }\n\n  .icon {\n    width: 10px;\n    margin-left: 6px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breadcrumbs": `components-Breadcrumbs-styles___breadcrumbs--X8AoF`,
	"breadcrumb": `components-Breadcrumbs-styles___breadcrumb--vDSlX`,
	"breadcrumbLink": `components-Breadcrumbs-styles___breadcrumbLink--NeSDk`,
	"icon": `components-Breadcrumbs-styles___icon--v8MDj`
};
module.exports = ___CSS_LOADER_EXPORT___;
